import * as React from 'react';
import { minimumSearchLength } from '../../utils/constants';
import ReactTooltip from 'react-tooltip';

export enum SearchType {
    Filespace = 'Filespace',
    Email = 'Email',
    FsUUID = 'Filespace UUID',
}

interface BackOfficeSearchProperties {
    onSearchClick: (searchValue: string, searchType: SearchType) => void;
    onChangeSearchType?: (searchType: SearchType) => void;
    searchValue?: string;
}

interface BackOfficeSearchState {
    searchType: SearchType;
    isSearchButtonDisabled: boolean;
}

export class Search extends React.Component<BackOfficeSearchProperties, BackOfficeSearchState> {
    private searchValue: string = '';

    constructor(props: BackOfficeSearchProperties) {
        super(props);
        this.onSearchValueUpdated = this.onSearchValueUpdated.bind(this);
        this.onSearchTypeChanged = this.onSearchTypeChanged.bind(this);
        this.changeSearchTypeOnTab = this.changeSearchTypeOnTab.bind(this);

        this.state = {
            searchType: SearchType.Filespace,
            isSearchButtonDisabled: true
        };
    }

    componentDidMount() {
        document.addEventListener('keydown', (event) => this.changeSearchTypeOnTab(event));
        if (this.props.searchValue) {
            this.searchValue = this.props.searchValue;
        }
    }

    render() {
        const searchClassName = this.state.isSearchButtonDisabled ? 'light disable' : 'light';
        let placeholder = 'Search by ';

        if (this.state.searchType === SearchType.Email) {
            placeholder += 'Email';
        }

        if (this.state.searchType === SearchType.Filespace) {
            placeholder += 'Filespace and Domain name';
        }

        if (this.state.searchType === SearchType.FsUUID) {
            placeholder += 'Filespace UUID';
        }

        return (
            <form
                onSubmit={(event) => {
                    event.preventDefault();
                }}
            >
                <div className="complexInput search">
                    <ReactTooltip/>
                    <div className="toggle">
                        <input
                            type="radio"
                            checked={this.state.searchType === SearchType.Filespace}
                            value={SearchType.Filespace}
                            id={SearchType.Filespace}
                            name="search-type"
                            onChange={(e) => this.onSearchTypeChanged(e.target.value as SearchType)}
                        />
                        <label htmlFor={SearchType.Filespace} data-tip="Search by Filespace and Domain">
                            <svg width="15px" height="15px" viewBox="0 0 15 15" version="1.1">
                                <path
                                    d="M13.3203125,9.1796875 C13.7630208,9.1796875 14.1536458,9.01041667 14.4921875,8.671875 C14.8307292,8.33333333 15,7.94270833 15,7.5 L15,7.5 L15,1.6796875 C15,1.23697917 14.8307292,0.846354167 14.4921875,0.5078125 C14.1536458,0.169270833 13.7630208,0 13.3203125,0 L13.3203125,0 L1.6796875,0 C1.23697917,0 0.846354167,0.169270833 0.5078125,0.5078125 C0.169270833,0.846354167 0,1.23697917 0,1.6796875 L0,1.6796875 L0,7.5 C0,7.94270833 0.169270833,8.33333333 0.5078125,8.671875 C0.846354167,9.01041667 1.23697917,9.1796875 1.6796875,9.1796875 L1.6796875,9.1796875 L13.3203125,9.1796875 Z M7.5,7.5 C6.82291667,7.5 6.23697917,7.25260417 5.7421875,6.7578125 C5.24739583,6.26302083 5,5.67708333 5,5 L5,5 L1.6796875,5 L1.6796875,1.6796875 L13.3203125,1.6796875 L13.3203125,5 L10,5 C10,5.67708333 9.75260417,6.26302083 9.2578125,6.7578125 C8.76302083,7.25260417 8.17708333,7.5 7.5,7.5 Z M13.3203125,15 C13.7630208,15 14.1536458,14.8307292 14.4921875,14.4921875 C14.8307292,14.1536458 15,13.7630208 15,13.3203125 L15,13.3203125 L15,10.8203125 L10,10.8203125 C10,11.4973958 9.75260417,12.0833333 9.2578125,12.578125 C8.76302083,13.0729167 8.17708333,13.3203125 7.5,13.3203125 C6.82291667,13.3203125 6.23697917,13.0729167 5.7421875,12.578125 C5.24739583,12.0833333 5,11.4973958 5,10.8203125 L5,10.8203125 L0,10.8203125 L0,13.3203125 C0,13.7630208 0.169270833,14.1536458 0.5078125,14.4921875 C0.846354167,14.8307292 1.23697917,15 1.6796875,15 L1.6796875,15 L13.3203125,15 Z"
                                />
                            </svg>
                        </label>
                        <input
                            type="radio"
                            checked={this.state.searchType === SearchType.FsUUID}
                            value={SearchType.FsUUID}
                            id={SearchType.FsUUID}
                            name="search-type"
                            onChange={(e) => this.onSearchTypeChanged(e.target.value as SearchType)}
                        />
                        <label htmlFor={SearchType.FsUUID} data-tip="Search by FS UUID">
                            <svg width="15px" height="15px" viewBox="0 0 15 15" version="1.1">
                                <path
                                    d="M13.3203125,9.1796875 C13.7630208,9.1796875 14.1536458,9.01041667 14.4921875,8.671875 C14.8307292,8.33333333 15,7.94270833 15,7.5 L15,7.5 L15,1.6796875 C15,1.23697917 14.8307292,0.846354167 14.4921875,0.5078125 C14.1536458,0.169270833 13.7630208,0 13.3203125,0 L13.3203125,0 L1.6796875,0 C1.23697917,0 0.846354167,0.169270833 0.5078125,0.5078125 C0.169270833,0.846354167 0,1.23697917 0,1.6796875 L0,1.6796875 L0,7.5 C0,7.94270833 0.169270833,8.33333333 0.5078125,8.671875 C0.846354167,9.01041667 1.23697917,9.1796875 1.6796875,9.1796875 L1.6796875,9.1796875 L13.3203125,9.1796875 Z M7.5,7.5 C6.82291667,7.5 6.23697917,7.25260417 5.7421875,6.7578125 C5.24739583,6.26302083 5,5.67708333 5,5 L5,5 L1.6796875,5 L1.6796875,1.6796875 L13.3203125,1.6796875 L13.3203125,5 L10,5 C10,5.67708333 9.75260417,6.26302083 9.2578125,6.7578125 C8.76302083,7.25260417 8.17708333,7.5 7.5,7.5 Z M13.3203125,15 C13.7630208,15 14.1536458,14.8307292 14.4921875,14.4921875 C14.8307292,14.1536458 15,13.7630208 15,13.3203125 L15,13.3203125 L15,10.8203125 L10,10.8203125 C10,11.4973958 9.75260417,12.0833333 9.2578125,12.578125 C8.76302083,13.0729167 8.17708333,13.3203125 7.5,13.3203125 C6.82291667,13.3203125 6.23697917,13.0729167 5.7421875,12.578125 C5.24739583,12.0833333 5,11.4973958 5,10.8203125 L5,10.8203125 L0,10.8203125 L0,13.3203125 C0,13.7630208 0.169270833,14.1536458 0.5078125,14.4921875 C0.846354167,14.8307292 1.23697917,15 1.6796875,15 L1.6796875,15 L13.3203125,15 Z"
                                />
                            </svg>
                        </label>
                        <input
                            type="radio"
                            checked={this.state.searchType === SearchType.Email}
                            value={SearchType.Email}
                            id={SearchType.Email}
                            name="search-type"
                            onChange={(e) => this.onSearchTypeChanged(e.target.value as SearchType)}
                        />
                        <label htmlFor={SearchType.Email} data-tip="Search by email">
                            <svg width="17px" height="14px" viewBox="0 0 17 14" version="1.1">
                                <path
                                    d="M15,13.359375 C15.4427083,13.359375 15.8268229,13.1901042 16.1523438,12.8515625 C16.4778646,12.5130208 16.640625,12.1223958 16.640625,11.6796875 L16.640625,11.6796875 L16.640625,1.6796875 C16.640625,1.23697917 16.4778646,0.846354167 16.1523438,0.5078125 C15.8268229,0.169270833 15.4427083,0 15,0 L15,0 L1.640625,0 C1.19791667,0 0.813802083,0.169270833 0.48828125,0.5078125 C0.162760417,0.846354167 0,1.23697917 0,1.6796875 L0,1.6796875 L0,11.6796875 C0,12.1223958 0.162760417,12.5130208 0.48828125,12.8515625 C0.813802083,13.1901042 1.19791667,13.359375 1.640625,13.359375 L1.640625,13.359375 L15,13.359375 Z M8.3203125,7.5 L1.640625,3.359375 L1.640625,1.6796875 L8.3203125,5.859375 L15,1.6796875 L15,3.359375 L8.3203125,7.5 Z"
                                />
                            </svg>
                        </label>
                    </div>
                    <input
                        className="large"
                        type="search"
                        value={this.searchValue}
                        autoFocus={true}
                        onChange={this.onSearchValueUpdated}
                        id="email-search"
                        placeholder={placeholder}
                    />
                    <button
                        className={searchClassName}
                        disabled={this.state.isSearchButtonDisabled}
                        onClick={() => this.props.onSearchClick(this.searchValue, this.state.searchType)}
                        type="submit"
                    >
                        <svg width="22px" height="22px" viewBox="0 0 22 22" version="1.1">
                            <path
                                d="M19.9804688,21.8554688 L21.8554688,19.9804688 L15.6445312,13.7695312 L14.6484375,13.7695312 L14.296875,13.4179688 C14.8046875,12.7929688 15.2539062,11.9628906 15.6445312,10.9277344 C16.0351562,9.89257812 16.2304688,8.96484375 16.2304688,8.14453125 C16.2304688,5.87890625 15.4492188,3.95507812 13.8867188,2.37304688 C12.3242188,0.791015625 10.4101562,0 8.14453125,0 C5.87890625,0 3.95507812,0.791015625 2.37304688,2.37304688 C0.791015625,3.95507812 0,5.87890625 0,8.14453125 C0,10.4101562 0.791015625,12.3242188 2.37304688,13.8867188 C3.95507812,15.4492188 5.87890625,16.2304688 8.14453125,16.2304688 C10.1757812,16.2304688 11.9335938,15.5859375 13.4179688,14.296875 L13.4179688,14.296875 L13.7695312,14.6484375 L13.7695312,15.6445312 L19.9804688,21.8554688 Z M8.14453125,13.7695312 C6.58203125,13.7695312 5.25390625,13.2226562 4.16015625,12.1289062 C3.06640625,11.0351562 2.51953125,9.70703125 2.51953125,8.14453125 C2.51953125,6.58203125 3.06640625,5.25390625 4.16015625,4.16015625 C5.25390625,3.06640625 6.58203125,2.51953125 8.14453125,2.51953125 C9.70703125,2.51953125 11.0351562,3.06640625 12.1289062,4.16015625 C13.2226562,5.25390625 13.7695312,6.58203125 13.7695312,8.14453125 C13.7695312,9.70703125 13.2226562,11.0351562 12.1289062,12.1289062 C11.0351562,13.2226562 9.70703125,13.7695312 8.14453125,13.7695312 Z"
                            />
                        </svg>
                    </button>
                </div>
            </form>);
    }

    private changeSearchTypeOnTab(e: any) {
        if (e.keyCode !== 9) {
            return;
        }
        e.preventDefault();

        if (this.state.searchType === SearchType.Filespace) {
            this.setState({ searchType: SearchType.FsUUID });
            if (this.props.onChangeSearchType) {
                this.props.onChangeSearchType(this.state.searchType);
            }
            return;
        }

        if (this.state.searchType === SearchType.FsUUID) {
            this.setState({ searchType: SearchType.Email });
            if (this.props.onChangeSearchType) {
                this.props.onChangeSearchType(this.state.searchType);
            }
            return;
        }

        if (this.state.searchType === SearchType.Email) {
            this.setState({ searchType: SearchType.Filespace });
            if (this.props.onChangeSearchType) {
                this.props.onChangeSearchType(this.state.searchType);

            }
            return;
        }
    }

    private onSearchValueUpdated(e: any): void {
        this.searchValue = e.target.value.trim();
        if (this.searchValue.length < minimumSearchLength) {
            this.setState({ isSearchButtonDisabled: true });
        }

        if (this.searchValue.length >= minimumSearchLength) {
            this.setState({ isSearchButtonDisabled: false });
        }
    }

    private onSearchTypeChanged(searchType: SearchType): void {
        this.setState({ searchType });
        if (this.props.onChangeSearchType) {
            this.props.onChangeSearchType(searchType);
        }
    }
}


// WEBPACK FOOTER //
// ./src/backoffice/components/common/Search.tsx